import React from "react";
import { Flower2 } from "lucide-react";
import ServicePage from "./ServicePage";
import gallery5 from "../../assets/images/jpg/gallery5.jpg";

const service = {
  title: "Property Maintenance",
  icon: Flower2,
  image: gallery5,
  description:
    "Reliable property maintenance to keep gardens, lawns, paths, and outdoor areas neat throughout the year.",
  longText:
    "Our property maintenance service is designed for homeowners, landlords, and commercial sites that need consistent outdoor care. We handle regular tidy-ups, pruning, green waste management, and seasonal work so your property stays well presented.",
  points: [
    "Regular garden tidy-ups",
    "Seasonal outdoor maintenance",
    "Pruning and hedge care",
    "Green waste clean-up",
    "Rental property support",
    "Commercial maintenance plans",
  ],
};

export default function PropertyMaintenance() {
  return <ServicePage service={service} />;
}
